module.exports = __webpack_public_path__ + "media/images/icons/outlined/file-image-7bd622b2ff2edac8069e0fe9715ceaa1.svg";